import {useEffect, useState} from "react";
import axios from "axios";
import {activity_test_problem_response, restUrl} from "../../../../apiUrl";
import {AboutPre, partition} from "../component/AboutPre";
import "../../../../root-css.css"
import {useLocation, useNavigate} from "react-router-dom";

export default function PreTrans() {

    const {state} = useLocation()

    const [processData, setProcessData] = useState(p);

    useEffect(() => {
        axios.get(`${restUrl}/activity_test_application?id=eq.${state.appId}`)
            .then(res => {
                if (res.data.length === 0) return;
                const data = res.data[0].preview_response.split(partition)
                const pr = p.map((it,index)=>({
                    originalText: it.originalText,
                    translateText: it.translateText,
                    response: data[index]
                }))
                setProcessData(pr);
            });
    }, []);

    // ✅ textarea 변경 핸들러
    const handleTextareaChange = (index, key, event) => {
        const newValue = event.target.value;
        setProcessData(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                [key]: newValue
            };
            return updated;
        });
    };

    const navigate = useNavigate();
    return (
        <>
            <AboutPre testId={state.testId}/>
            <ul className={`flex gap-3`}>
                {["원문", "번역된 내용", "에디터"].map((item, index) => (
                    <li key={index} className={`w-full px-2 py-3 bg-slate-800 text-white`}>{item}</li>
                ))}
            </ul>
            <ul className={`w-full`}>
                {processData.map((item, index) => (
                    <li
                        key={index}
                        className={`flex w-full gap-3 [&_*]:p-2 mb-1 [&_*]:w-full [&_*]:h-[10rem] [&_*]:border-2`}
                    >
                        {/* 원문 - 읽기 전용 */}
                        <textarea
                            value={item.originalText}
                            readOnly
                            className={`border-2 border-black`}
                        />
                        {/* 번역된 내용 - 읽기 전용 */}
                        <textarea
                            value={item.translateText}
                            readOnly
                            className={`border-2 border-black`}
                        />
                        {/* 에디터 - 수정 가능 */}
                        <textarea
                            value={item.response}
                            className={`border-2 border-black`}
                            onChange={(e) => handleTextareaChange(index, 'response', e)}
                        />
                    </li>
                ))}
            </ul>
            <button onClick={async () => {
                const ok = window.confirm('제출하시겠습니까?')
                if (!ok) return
                const cleanedArray = processData.map(it=>it.response).join(partition);
                await axios.patch(`${restUrl}/activity_test_application?id=eq.${state.appId}`, {preview_response:cleanedArray})
                navigate(-1)
            }}
            >제출하기
            </button>
        </>
    );
}

const p=[
    {
        originalText: '(원문) 새로운 프로젝트가 시작되었어요.',
        translateText: '(번역본) New project is started.',
        response: '(수정본)',
    },
    {
        originalText: '(원문) 이번 기회를 통해 저희 팀은 크게 성장할 거예요.',
        translateText: '(번역본) Through this chance, our team will growth big.',
        response: '(수정본)',
    },
    {
        originalText: '(원문) 모두의 노력이 빛을 발할 거라 믿어요.',
        translateText: '(번역본) I believe everyone\'s effort will shine light.',
        response: '(수정본)',
    },
]